module.exports = __webpack_public_path__ + "src/assets/img/s-protection_w.8d21a42c.svg";